<mat-card appearance="outlined">
  <mat-card-content>
    <app-form-default [formData$]="formData$" (submitted)="onSubmit()"></app-form-default>
  </mat-card-content>
</mat-card>